import React, { Component } from 'react';
import '../../css/moj.css';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import Firebase from '../Firebase';
import { Table } from 'react-bootstrap';
import Schools from '../../Data/Schools.json';
import Qestions1 from '../../Data/Qestions1.json';
import Score from '../../Data/Score.json';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
class Moj_go_th extends Component {

    render() {
        return (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <div className="data_center">
                    <p style={{ textAlign: 'center', fontSize: 26 }}>
                        <strong>
                            แบบสอบถาม
                        <br></br>
                        โครงการโรงเรียนยุติธรรมอุปถัมภ์
                    <br></br>
                        สำนักงานกิจการยุติธรรม
                    <br></br>
                        (สำหรับนักเรียนที่เข้าร่วมกิจกรรม)
                    </strong>
                    </p>
                    <br></br>
                    <hr></hr>
                    <Data></Data>
                    <div>
                        <p>ติดต่อผู้พัฒนา email:adison.ra.56@ubu.ac.th  line-ID:oqiew2537</p>
                    </div>
                </div>
            </div>
        )
    }
}


class Data extends Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 0,
            // School_ID: '',
            School_name: '',
            Sex: '',
            Age: '',
            Level: '',
            Join: '',
            Join_number: '',
            // school1: [],
            Answer1: ['', '', '', '', '', '', '', '', '', '', '', ''],///12
            Answer2: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],//15
            Answer3: ['', '', '', '', '', '', '', '', '', '', '', ''],//12
            tQestions1: [],
            tQestions2: [],
            tQestions3: [],
            // Show_score1:'',
            // Show_score3:'',


        }
    }
    componentDidMount() {

        // const school1 = [];
        const tQestions1 = [];
        const tQestions2 = [];
        const tQestions3 = [];
        let index = 0;

        Qestions1.Q2.forEach((doc) => {
            if (index < 5) {
                tQestions1.push(
                    <tr key={index}>
                        <td>
                            {doc.Number}
                        </td>
                        <td>
                            {doc.Detail}
                        </td>
                        <td>
                            <input required type="radio" name={"Q2" + doc.Number} style={{ margin: 5 }} onChange={this.ans2.bind(this, parseInt(doc.Number, 10) - 1, '1')} />
                        </td>
                        <td>
                            <input type="radio" name={"Q2" + doc.Number} style={{ margin: 5 }} onChange={this.ans2.bind(this, parseInt(doc.Number, 10) - 1, '2')} />
                        </td>
                        <td>
                            <input type="radio" name={"Q2" + doc.Number} style={{ margin: 5 }} onChange={this.ans2.bind(this, parseInt(doc.Number, 10) - 1, '3')} />
                        </td>
                        <td>
                            <input type="radio" name={"Q2" + doc.Number} style={{ margin: 5 }} onChange={this.ans2.bind(this, parseInt(doc.Number, 10) - 1, '4')} />
                        </td>
                        <td>
                            <input type="radio" name={"Q2" + doc.Number} style={{ margin: 5 }} onChange={this.ans2.bind(this, parseInt(doc.Number, 10) - 1, '5')} />
                        </td>

                    </tr>
                )
            } else if (index < 10) {
                tQestions2.push(
                    <tr key={index}>
                        <td>
                            {doc.Number}
                        </td>
                        <td>
                            {doc.Detail}
                        </td>
                        <td>
                            <input required type="radio" name={"Q2" + doc.Number} style={{ margin: 5 }} onChange={this.ans2.bind(this, parseInt(doc.Number, 10) - 1, '1')} />
                        </td>
                        <td>
                            <input type="radio" name={"Q2" + doc.Number} style={{ margin: 5 }} onChange={this.ans2.bind(this, parseInt(doc.Number, 10) - 1, '2')} />
                        </td>
                        <td>
                            <input type="radio" name={"Q2" + doc.Number} style={{ margin: 5 }} onChange={this.ans2.bind(this, parseInt(doc.Number, 10) - 1, '3')} />
                        </td>
                        <td>
                            <input type="radio" name={"Q2" + doc.Number} style={{ margin: 5 }} onChange={this.ans2.bind(this, parseInt(doc.Number, 10) - 1, '4')} />
                        </td>
                        <td>
                            <input type="radio" name={"Q2" + doc.Number} style={{ margin: 5 }} onChange={this.ans2.bind(this, parseInt(doc.Number, 10) - 1, '5')} />
                        </td>

                    </tr>)
            } else {
                tQestions3.push(<tr key={index}>
                    <td>
                        {doc.Number}
                    </td>
                    <td>
                        {doc.Detail}
                    </td>
                    <td>
                        <input required type="radio" name={"Q2" + doc.Number} style={{ margin: 5 }} onChange={this.ans2.bind(this, parseInt(doc.Number, 10) - 1, '1')} />
                    </td>
                    <td>
                        <input type="radio" name={"Q2" + doc.Number} style={{ margin: 5 }} onChange={this.ans2.bind(this, parseInt(doc.Number, 10) - 1, '2')} />
                    </td>
                    <td>
                        <input type="radio" name={"Q2" + doc.Number} style={{ margin: 5 }} onChange={this.ans2.bind(this, parseInt(doc.Number, 10) - 1, '3')} />
                    </td>
                    <td>
                        <input type="radio" name={"Q2" + doc.Number} style={{ margin: 5 }} onChange={this.ans2.bind(this, parseInt(doc.Number, 10) - 1, '3')} />
                    </td>
                    <td>
                        <input type="radio" name={"Q2" + doc.Number} style={{ margin: 5 }} onChange={this.ans2.bind(this, parseInt(doc.Number, 10) - 1, '5')} />
                    </td>

                </tr>)
            }
            index++;
        })
        this.setState({
            tQestions1,
            tQestions2,
            tQestions3,

        })

    }

    onChange = (e) => {
        const state = this.state
        state[e.target.name] = e.target.value;
        this.setState(state);

    }
    nextStep2 = (e) => {
        e.preventDefault();
        if (this.state.School_name !== '') {
            this.setState({
                step: 2
            })

        } else {
            alert("กรุณากรอกข้อมูลให้ครบ");
        }

    }
    nextStep3 = (e) => {
        e.preventDefault();
        this.setState({
            step: 3
        })

    }
    nextStep4 = (e) => {
        e.preventDefault();
        this.setState({
            step: 4
        })

    }

    ans1(id, value) {
        let Answer1 = this.state.Answer1;

        Answer1[id] = value;
        console.log(id, '=', value);
        this.setState({
            Answer1
        })

    }
    ans2(id, value) {
        let Answer2 = this.state.Answer2;
        Answer2[id] = value;
        console.log(id, '=', value);
        this.setState({
            Answer2
        })

    }
    ans3(id, value) {
        let Answer3 = this.state.Answer3;

        Answer3[id] = value;
        console.log(id, '=', value);
        this.setState({
            Answer3
        })

    }
    onSubmit = (e) => {
        e.preventDefault();
        let Score_temp1 = 0;
        let Score_temp2 = 0;
        let Score_temp3 = 0;
        const { School_name, Sex, Age, Level, Join, Join_number, } = this.state;
        const { Answer1, Answer2, Answer3 } = this.state;
        let save = true;
        Answer1.forEach((element, i) => {
            Score_temp1 += parseInt(Score.Q1[i].Score[parseInt(element, 10) - 1], 10);
            console.log("ข้อที่", i + 1, "ตอบ", element, "ได้คะแนน", Score.Q1[i].Score[parseInt(element, 10) - 1]);
        })
        Answer3.forEach((element, i) => {
            Score_temp3 += parseInt(Score.Q3[i].Score[parseInt(element, 10) - 1], 10);
            console.log("ข้อที่", i + 1, "ตอบ", element, "ได้คะแนน", Score.Q3[i].Score[parseInt(element, 10) - 1]);
        })
        const Create_date = new Date();

        if (save) {

            Firebase.firestore().collection('MOJ1S').add({
                School_name, Sex, Age, Level, Join, Join_number, Score1: Score_temp1, Score3: Score_temp3,
                Answer1, Answer2, Answer3, Create_date, rule: 'นักเรียน'
            }).then((doc) => {
                console.log('success');
                confirmAlert({
                    title: 'บันทึกสำเร็จ',
                    message: ' ขอบคุณที่สละเวลาตอบแบบสอบถาม',
                    closeOnClickOutside: true,
                    buttons: [
                        {
                            label: 'ตกลง',
                            onClick: () => this.setState({
                                reset_password: false,
                                login: true,

                            })
                        },

                    ]
                });
                this.setState({
                    step: 0,
                    School_name: '',
                    // School_ID: '',
                    Sex: '',
                    Age: '',
                    Level: '',
                    Join: '',
                    Join_number: '',
                    // school1: [],
                    Answer1: ['', '', '', '', '', '', '', '', '', '', '', ''],///12
                    Answer2: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],//15
                    Answer3: ['', '', '', '', '', '', '', '', '', '', '', ''],//12
                    // Show_score1,Show_score3
                })
            }).catch((error) => {
                console.log(error, 'error');
            })
        } else {
            alert("กรุณากรอกข้อมูลให้ครบ");
        }

    }
    render() {
        const { School_name, Join, } = this.state;
        if (this.state.step === 0) {
            return (
                <div>
                    <div style={{ margin: '3%' }}>
                        <p style={{ textDecoration: 'underline', fontSize: 20 }}>
                            คำชี้แจง
                        </p>

                        <p style={{ fontSize: 18, lineHeight: 2, }}>
                            <span style={{ marginLeft: '3%', marginRight: '3%' }}> </span>
                            โครงการโรงเรียนยุติธรรมอุปถัมภ์ ดำเนินการโดยหน่วยงานในสังกัดกระทรวงยุติธรรม 10 หน่วยงาน ร่วมมือกับสถานศึกษาในพื้นที่
                            ทั้งในสังกัดกระทรวงศึกษาธิการ กระทรวงมหาดไทย และกรุงเทพมหานคร เพื่อการจัดกิจกรรมเสริมสร้างจิตสำนึกรักความยุติธรรม
                            การรับรู้กฎกติกาที่เหมาะสมกับช่วงอายุของเด็กแต่ละวัย ภายใต้กรอบเนื้อหาการดำเนินโครงการฯ 4 กรอบเนื้อหาได้แก่ 1. การป้องกันตนเองจากภัยสังคม 2.
                            การสร้างจิตสำนึกและวินัยในตนเอง 3. การรู้เท่าทันและห่างไกลจากยาเสพติด 4. การต่อต้านการทุจริตคอร์รัปชัน ตามแนวทาง “โรงเรียนดี มีภูมิคุ้มกัน รู้เท่าทันภัยสังคม”
                            โดยมีรูปแบบการจัดกิจกรรมสร้างภูมิคุ้มกันทางสังคมสำหรับเด็กและเยาวชน เน้นการป้องกันและร่วมแก้ไขปัญหาที่เกิดขึ้นในโรงเรียนด้วยตนเองเพื่อให้เกิดความยั่งยืน
                            ผ่านกระบวนการระดมความคิด วิเคราะห์สภาพปัญหา รวมทั้งประเมินผลสำเร็จในการดำเนินกิจกรรมในโรงเรียนทั้งด้านผลผลิต และผลลัพธ์ของการดำเนินกิจกรรม
                            โดยการจัดทำเครื่องมือการประเมินผลการดำเนินกิจกรรมในโรงเรียน และประเมินผลการดำเนินกิจกรรม เพื่อประเมินผลลัพธ์ที่เกิดกับตัวเด็กและเยาวชนที่เข้าร่วมกิจกรรม
                             ซึ่งจะใช้เป็นข้อมูลในการพัฒนากิจกรรมที่เหมาะสมกับเด็กและเยาวชนและตอบสนองความต้องการที่สามารถนำไปสู่การแก้ไขปัญหา
                             อันจะเป็นการพัฒนาศักยภาพให้เด็กและเยาวชนมีภูมิคุ้มกันที่ดียิ่งขึ้นต่อไป ทั้งนี้ มีการติดตามและประเมินผลการดำเนินกิจกรรมภายใต้โครงการโรงเรียนยุติธรรม
                              โดยแบบสอบถามแบ่งออกเป็น 3 ส่วนดังนี้
                            <br></br>
                            <strong>ส่วนที่ 1 </strong>ข้อมูลทั่วไปของผู้ตอบแบบสอบถาม<br></br>
                            <strong>ส่วนที่ 2 </strong>การประเมินผลของนักเรียนที่เข้าร่วมกิจกรรมภายใต้โครงการโรงเรียนยุติธรรมอุปถัมภ์<br></br>
                            <span style={{ marginLeft: '3%' }}></span>2.1 ประเมินผลการเรียนรู้ของนักเรียนหลังเข้าร่วมกิจกรรมภายใต้โครงการโรงเรียนยุติธรรมอุปถัมภ์<br></br>
                            <span style={{ marginLeft: '3%' }}></span>2.2 ประเมินผลความเหมาะสมการดำเนินกิจกรรมภายใต้โครงการโรงเรียนยุติธรรมอุปถัมภ์<br></br>
                            <span style={{ marginLeft: '3%' }}></span>2.3 ประเมินผลพฤติกรรมนักเรียนหลังการเข้าร่วมกิจกรรมภายใต้โครงการโรงเรียนยุติธรรมอุปถัมภ์<br></br>
                            <strong>ส่วนที่ 3 </strong>ข้อเสนอแนะ<br></br>
                            <span style={{ marginLeft: '3%' }}> </span>
                            ทั้งนี้ เพื่อให้ผลการศึกษาสามารถสะท้อนความเป็นจริงตามความความคิดเห็นของท่านได้เป็นอย่างดีท่านสามารถแสดงความคิดเห็นได้อย่างเป็นอิสระ
                            และขอยืนยันว่าข้อมูลส่วนบุคคลและคำตอบของท่านจะถูกเก็บไว้เป็นความลับและไม่ถูกนำไปเผยแพร่หรือใช้เพื่อการใด ๆ ทั้งสิ้น
                            ความร่วมมือของท่านจะช่วยสนับสนุนการพัฒนารูปแบบการดำเนินงานของหน่วยงานภาครัฐในการป้องกันอาชญากรรมให้กับประชาชนภายใต้โครงการโรงเรียนยุติธรรมอุปถัมภ์
                            จะช่วยสนับสนุนการพัฒนารูปแบบกิจกรรมที่เหมาะสมแก่เด็กและเยาวชนภายใต้การดำเนินงานโครงการโรงเรียนยุติธรรมอุปถัมภ์ โดยความร่วมมือของหน่วยงานสังกัดกระทรวงยุติธรรม
                        </p>

                    </div>
                    <div style={{ justifyContent: 'center', display: 'flex', marginBottom: 100 }}>
                        <button type="submit" onClick={() => { this.setState({ step: 1 }) }} style={{ padding: 10, borderRadius: 10, backgroundColor: '#00ff80', fontSize: 20 }}>เริ่มทำแบบสอบถาม</button>
                    </div>
                </div>
            )
        } else if (this.state.step === 1) {
            return (
                <div>
                    <p>*ไม่ต้องใส่คำว่าโรงเรียน</p>
                    {/* <Autocomplete
                            id="combo-box-demo"
                            options={this.state.school1}
                            getOptionLabel={option => option.title}
                            disableClearable={true}
                            style={{ width: '80%' }}
                            onChange={(event, value) => { this.onChange2(value) }}
                            renderInput={params => (
                                <TextField {...params} label="โรงเรียน" variant="outlined" name="School_name" fullWidth />
                            )}
                        /> */}
                    <input required placeholder="โรงเรียน" style={{ width: '50%', height: 35, borderRadius: 10 }} onChange={(e) => this.setState({ School_name: e.target.value })}></input>
                    <br></br>
                    <br></br>
                    {School_name !== '' ?
                        <form onSubmit={this.nextStep2}>
                            {/* 1 */}
                            <p><strong className="titie3">ส่วนที่ 1 : ข้อมูลทั่วไปของผู้ตอบแบบสอบถาม  </strong></p>
                            <div style={{ marginLeft: '3%', marginRight: '3%' }}>
                                <div className="input-form">
                                    <label>1. เพศ: <label style={{ color: "red" }}>*</label></label>
                                    <div style={{ marginLeft: 20 }}>
                                        <div>
                                            <input required type="radio" name="Sex" value="ชาย" style={{ maring: 5 }} onChange={this.onChange} />ชาย
                                            </div>
                                        <div>
                                            <input type="radio" name="Sex" value="หญิง" style={{ maring: 5 }} onChange={this.onChange} />หญิง
                                            </div>

                                    </div>
                                </div>
                                <div className="input-form">
                                    <label>2. อายุ: <label style={{ color: "red" }}>*</label></label>
                                    <div style={{ marginLeft: 20 }}>
                                        <div>
                                            <input required type="radio" name="Age" value="7 - 9 ปี" style={{ margin: 5 }} onChange={this.onChange} />7 - 9 ปี
                                            </div>
                                        <div>
                                            <input type="radio" name="Age" value="10 - 12 ปี" style={{ margin: 5 }} onChange={this.onChange} />10 - 12 ปี
                                            </div>
                                        <div>
                                            <input type="radio" name="Age" value="13 - 15 ปี" style={{ margin: 5 }} onChange={this.onChange} />13 - 15 ปี
                                            </div>
                                        <div>
                                            <input type="radio" name="Age" value="16 - 18 ปี" style={{ margin: 5 }} onChange={this.onChange} />16 - 18 ปี
                                             </div>
                                    </div>
                                </div>
                                <div className="input-form">
                                    <label>3. ช่วงชั้น: <label style={{ color: "red" }}>*</label></label>
                                    <div style={{ marginLeft: 20 }}>
                                        <div>
                                            <input required type="radio" name="Level" value="ประถมศึกษาปีที่ 1 – 3" style={{ margin: 5 }} onChange={this.onChange} />ประถมศึกษาปีที่ 1 – 3
                                            </div>
                                        <div>
                                            <input type="radio" name="Level" value="ประถมศึกษาปีที่ 4 – 6" style={{ margin: 5 }} onChange={this.onChange} />ประถมศึกษาปีที่ 4 – 6
                                            </div>
                                        <div>
                                            <input type="radio" name="Level" value="มัธยมศึกษาปีที่ 1 – 3" style={{ margin: 5 }} onChange={this.onChange} />มัธยมศึกษาปีที่   1 – 3
                                            </div>
                                        <div>
                                            <input type="radio" name="Level" value="มัธยมศึกษาปีที่ 4 – 6" style={{ margin: 5 }} onChange={this.onChange} />มัธยมศึกษาปีที่   4 – 6
                                             </div>
                                    </div>
                                </div>
                                <div className="input-form">
                                    <label>4. นักเรียนเคยเข้าร่วมโครงการโรงเรียนยุติธรรมอุปถัมภ์หรือไม่: <label style={{ color: "red" }}>*</label></label>
                                    <div style={{ marginLeft: 20 }}>
                                        <div>
                                            <input required type="radio" name="Join" value="เคย" style={{ margin: 5 }} onChange={this.onChange} />เคย (ตอบคำถามข้อถัดไป)
                                            </div>
                                        <div>
                                            <input type="radio" name="Join" value="ไม่เคย" style={{ margin: 5 }} onChange={this.onChange} />ไม่เคย
                                            </div>
                                    </div>
                                </div>
                                {Join === 'เคย' ?
                                    <div className="input-form">
                                        <label>5. ถ้านักเรียนเคยเข้าร่วมโครงการโรงเรียนยุติธรรมอุปถัมภ์ นักเรียนเข้าร่วมกี่ครั้ง (ต่อปีงบประมาณ): <label style={{ color: "red" }}>*</label></label>
                                        <div style={{ marginLeft: 20 }}>
                                            <div>

                                                <input required type="radio" name="Join_number" value="1 ครั้ง" style={{ margin: 5 }} onChange={this.onChange} />1 ครั้ง
                                            </div>
                                            <div>
                                                <input type="radio" name="Join_number" value="2 – 3 ครั้ง" style={{ margin: 5 }} onChange={this.onChange} />2 – 3 ครั้ง
                                            </div>
                                            <div>
                                                <input type="radio" name="Join_number" value="มากกว่า 3 ครั้ง" style={{ margin: 5 }} onChange={this.onChange} />มากกว่า 3 ครั้ง
                                            </div>

                                        </div>
                                    </div>
                                    : <div></div>}

                            </div>
                            {/* 1 */}
                            <div style={{ justifyContent: 'center', display: 'flex', marginBottom: 100 }}>
                                <button type="submit" style={{ padding: 10, borderRadius: 10, backgroundColor: '#00ff80', fontSize: 20 }}>ถัดไป</button>
                            </div>
                        </form>

                        : <div></div>
                    }
                </div>
            )
        } else if (this.state.step === 2) {
            return (

                <form onSubmit={this.nextStep3}>

                    {/*    2 */}
                    <p><strong className="titie3">ส่วนที่ 2 : การประเมินผลนักเรียนที่เข้าร่วมกิจกรรมภายใต้โครงการโรงเรียนยุติธรรมอุปถัมภ์ </strong></p>
                    <div style={{ marginLeft: '3%', marginRight: '3%' }}>
                        {/* 2.1 */}
                        <p>2.1 ประเมินผลการเรียนรู้ของนักเรียนที่เข้าร่วมกิจกรรมภายใต้โครงการโรงเรียนยุติธรรมอุปถัมภ์</p>
                        <p><strong style={{ textDecoration: 'underline' }}>คำชี้แจง </strong> กรุณาประเมินผลการเรียนรู้หลังการเข้าร่วมกิจกรรมในฐานะผู้เข้าร่วม โดยทำเครื่องหมายถูก (√) ในช่องที่นักเรียนคิดว่าถูกต้องที่สุด</p>
                        <hr></hr>
                        <div style={{ marginLeft: '3%' }}>
                            {Qestions1.Q1.map((element, i) => {
                                return (
                                    <div key={i}>
                                        <p>ข้อ {element.Number}. {element.Detail}</p>
                                        <div style={{ marginLeft: 20, flexDirection: 'column' }}>
                                            <input required type="radio" name={"Q1" + element.Number} style={{ margin: 5 }} onChange={this.ans1.bind(this, parseInt(element.Number, 10) - 1, '1')} />{element.No1}
                                            <br></br>
                                            <input type="radio" name={"Q1" + element.Number} style={{ margin: 5 }} onChange={this.ans1.bind(this, parseInt(element.Number, 10) - 1, '2')} />{element.No2}
                                        </div>
                                        <hr></hr>
                                    </div>
                                )

                            })}
                        </div>
                        {/* 2.1 */}

                    </div>
                    <div style={{ justifyContent: 'center', display: 'flex', marginBottom: 100 }}>
                        <button type="submit" style={{ padding: 10, borderRadius: 10, backgroundColor: '#00ff80', fontSize: 20 }}>ถัดไป</button>
                    </div>
                </form>
            )
        } else if (this.state.step === 3) {
            return (
                <form onSubmit={this.nextStep4}>
                    {/* 2.2 */}
                    <p>2.2 ประเมินผลความเหมาะสมนักเรียนที่เข้าร่วมกิจกรรมภายใต้โครงการโรงเรียนยุติธรรมอุปถัมภ์</p>
                    <div style={{ marginLeft: '3%' }}>
                        <p><strong style={{ textDecoration: 'underline' }}>คำชี้แจง </strong>
                                        กรุณาประเมินผลการเข้าร่วมกิจกรรมในฐานะผู้เข้าร่วมโดยทำเครื่องหมายถูก (√) ในช่องที่ตรงกับความคิดเห็นท่าน</p>
                        <p>ระดับ 5		มีค่าเท่ากับ	มากที่สุด</p>
                        <p>ระดับ 4		มีค่าเท่ากับ	มาก</p>
                        <p>ระดับ 3		มีค่าเท่ากับ	พอใช้</p>
                        <p>ระดับ 2		มีค่าเท่ากับ	น้อย</p>
                        <p>ระดับ 1		มีค่าเท่ากับ	น้อยที่สุด</p>
                    </div>
                    <Table striped bordered hover size="sm" style={{ width: '100%' }}>
                        <thead>
                            <tr>
                                <th rowSpan="2" style={{ verticalAlign: 'top' }}>ข้อ</th>
                                <th rowSpan="2" style={{ verticalAlign: 'top', textAlign: 'center' }}>ประเมินผลกิจกรรม</th>
                                <th colSpan="5">ระดับ</th>
                            </tr>
                            <tr>
                                <th style={{ textAlign: 'center' }}>1</th>
                                <th style={{ textAlign: 'center' }}>2</th>
                                <th style={{ textAlign: 'center' }}>3</th>
                                <th style={{ textAlign: 'center' }}>4</th>
                                <th style={{ textAlign: 'center' }}>5</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr key={101}>
                                <td></td>
                                <td><strong>ด้านกระบวนการและรูปแบบการดำเนินกิจกรรม</strong></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>

                            {this.state.tQestions1}
                            <tr key={102}>
                                <td></td>
                                <td><strong>ด้านเนื้อหาและสื่อที่ใช้ประกอบ</strong></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            {this.state.tQestions2}
                            <tr key={103}>
                                <td></td>
                                <td><strong>ด้านความเหมาะสมของการดำเนินกิจกรรม</strong></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            {this.state.tQestions3}

                        </tbody>
                    </Table>
                    <br></br>
                    <p>ข้อเสนอแนะต่อการดำเนินกิจกรรม</p>
                    <textarea rows="4" style={{ borderRadius: 10, width: '80%', marginLeft: '3%' }} onChange={str => this.ans2(15, str.target.value)}></textarea>
                    <br></br>
                    {/* 2.2 */}
                    <div style={{ justifyContent: 'center', display: 'flex', marginBottom: 100 }}>
                        <button type="submit" style={{ padding: 10, borderRadius: 10, backgroundColor: '#00ff80', fontSize: 20 }}>ถัดไป</button>
                    </div>
                </form>

            )
        } else if (this.state.step === 4) {
            return (
                <form onSubmit={this.onSubmit}>

                    <p>2.3 ประเมินผลความเหมาะสมนักเรียนหลังการเข้าร่วมกิจกรรมภายใต้โครงการโรงเรียนยุติธรรมอุปถัมภ์</p>
                    <p><strong style={{ textDecoration: 'underline' }}>คำชี้แจง </strong>
                                    กรุณาประเมินผลการเข้าร่วมกิจกรรมในฐานะผู้เข้าร่วมโดยทำเครื่องหมายถูก (√) ในช่องที่ตรงกับความคิดเห็นท่าน</p>
                    <hr></hr>
                    <div style={{ marginLeft: '3%' }}>
                        {Qestions1.Q3.map((element, i) => {
                            return (
                                <div key={i}>
                                    <p>ข้อ {element.Number}. {element.Detail}</p>
                                    <div style={{ marginLeft: 20, flexDirection: 'column' }}>
                                        <input required type="radio" name={"Q1" + element.Number} style={{ margin: 5 }} onChange={this.ans3.bind(this, parseInt(element.Number, 10) - 1, '1')} />{element.No1}
                                        <br></br>
                                        <input type="radio" name={"Q1" + element.Number} style={{ margin: 5 }} onChange={this.ans3.bind(this, parseInt(element.Number, 10) - 1, '2')} />{element.No2}
                                    </div>
                                    <hr></hr>
                                </div>
                            )

                        })}
                    </div>



                    <div style={{ justifyContent: 'center', display: 'flex', marginBottom: 100 }}>
                        <button type="submit" style={{ padding: 10, borderRadius: 10, backgroundColor: '#00ff80', fontSize: 20 }}>ส่งคำตอบ</button>
                    </div>
                </form>
            )
        }
    }
}

export default Moj_go_th




